import React, { useState } from "react";
import { leadsAPI } from "../../services/api";
import "./Forms.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", email: "", phone: "", subject: "", message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");
    try {
      await leadsAPI.submitContact(formData);
      setSubmitMessage("success:Mensaje enviado. Nos pondremos en contacto pronto.");
      setFormData({ firstName: "", lastName: "", email: "", phone: "", subject: "", message: "" });
    } catch (error) {
      setSubmitMessage("error:Error al enviar el mensaje. Intente de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form">
      <h3>Contáctenos</h3>
      {submitMessage && (
        <div className={`message ${submitMessage.startsWith("success") ? "success" : "error"}`}>
          {submitMessage.split(":")[1]}
        </div>
      )}
      <div className="form-row">
        <div className="form-group"><label>Nombre *</label><input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="Juan" /></div>
        <div className="form-group"><label>Apellido *</label><input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Pérez" /></div>
      </div>
      <div className="form-row">
        <div className="form-group"><label>Correo Electrónico *</label><input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="email@ejemplo.com" /></div>
        <div className="form-group"><label>Teléfono</label><input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+598 99 123 456" /></div>
      </div>
      <div className="form-group"><label>Asunto *</label><input type="text" name="subject" value={formData.subject} onChange={handleChange} required placeholder="¿En qué podemos ayudarle?" /></div>
      <div className="form-group"><label>Mensaje *</label><textarea name="message" value={formData.message} onChange={handleChange} required rows="5" placeholder="Escriba su mensaje aquí..." /></div>
      <button type="submit" className="btn-submit" disabled={isSubmitting}>
        {isSubmitting ? "Enviando..." : "Enviar Mensaje"}
      </button>
    </form>
  );
};

export default ContactForm;
